module.exports = __webpack_public_path__ + "static/img/DJ.273f5090.svg";